import type {InventoryPlotRepository} from '@/domain/interfaces/InventoryPlotRepository';

export class GetAllInventoryPlotsByForestMassUuidUseCase {
  constructor(private readonly repository: InventoryPlotRepository) {}
  async execute(forestMassUuid: string) {
    return this.repository.list(forestMassUuid);
  }
}
